import { Component, Input, OnChanges } from '@angular/core';
// -- components --
import { CarouselModule } from 'primeng/carousel';
import { CarouselItemComponent } from './components/carousel-item/carousel-item.component';
import { MatIconModule } from '@angular/material/icon';

import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-jc3-block-1',
    standalone: true,
    imports: [
        CarouselModule,
        CarouselItemComponent,
        MatIconModule,
        TranslateModule,
        CommonModule,
    ],
    templateUrl: './jc3-block-1.component.html',
    styleUrl: './jc3-block-1.component.scss',
})
export class Jc3Block1Component implements OnChanges {
    @Input() whatsNewData: any = {};

    private _displayData: any[] | null = null;
    private _lastWhatsNewData: any = null;

    isMobile: boolean = window.innerWidth < 768;
    isTablet: boolean = window.innerWidth >= 768 && window.innerWidth <= 1024;
    isDeskTop: boolean = window.innerWidth > 1024;

    defaultWhatsNewData: {
        link: string;
        linkText: string;
        image: string;
        description: string;
        title: string;
    }[] = [
        {
            image: 'assets/images/Jc3/Jc-Carousel-Img.png',
            title: 'How Platinum Phase Sdn Bhd obtained ESG status that help boost their business',
            description:
                'An ISO-certified company specializing in polymer solutions, focusing on plastic recycling and advanced powder coating. They promote sustainability by using recycled plastics, VOC-free coatings, and solar energy to reduce environmental impact.',
            link: 'http://www.google.com/',
            linkText: 'Learn More',
        },
        {
            title: 'How Platinum Phase Sdn Bhd obtained ESG status that help boost their business',
            description:
                'An ISO-certified company specializing in polymer solutions, focusing on plastic recycling and advanced powder coating. They promote sustainability by using recycled plastics, VOC-free coatings, and solar energy to reduce environmental impact.',
            image: 'assets/images/Jc3/Jc-Carousel-Img.png',
            link: 'http://www.google.com/',
            linkText: 'Learn More',
        },
        {
            title: 'How Platinum Phase Sdn Bhd obtained ESG status that help boost their business',
            description:
                'An ISO-certified company specializing in polymer solutions, focusing on plastic recycling and advanced powder coating. They promote sustainability by using recycled plastics, VOC-free coatings, and solar energy to reduce environmental impact.',
            image: 'assets/images/Jc3/Jc-Carousel-Img.png',
            link: 'http://www.google.com/',
            linkText: 'Learn More',
        },
        {
            title: 'How Platinum Phase Sdn Bhd obtained ESG status that help boost their business',
            description:
                'An ISO-certified company specializing in polymer solutions, focusing on plastic recycling and advanced powder coating. They promote sustainability by using recycled plastics, VOC-free coatings, and solar energy to reduce environmental impact.',
            image: 'assets/images/Jc3/Jc-Carousel-Img.png',
            link: 'http://www.google.com/',
            linkText: 'Learn More',
        },
        {
            title: 'How Platinum Phase Sdn Bhd obtained ESG status that help boost their business',
            description:
                'An ISO-certified company specializing in polymer solutions, focusing on plastic recycling and advanced powder coating. They promote sustainability by using recycled plastics, VOC-free coatings, and solar energy to reduce environmental impact.',
            image: 'assets/images/Jc3/Jc-Carousel-Img.png',
            link: 'http://www.google.com/',
            linkText: 'Learn More',
        },
    ];

    ngOnChanges(): void {
        this.isMobile = window.innerWidth < 768;
        this.isTablet = window.innerWidth >= 768 && window.innerWidth <= 1024;
        this.isDeskTop = window.innerWidth > 1024;
    }

    get displayData() {
        // Only recalculate if whatsNewData has actually changed
        if (
            this._displayData === null ||
            this._lastWhatsNewData !== this.whatsNewData
        ) {
            this._lastWhatsNewData = this.whatsNewData;
            this._displayData = this.processDisplayData();
        }
        return this._displayData;
    }

    getImageCardUrl(article: any) {
        if (this.isDeskTop) {
            return article?.desktopcard_url ?? '';
        } else if (this.isMobile) {
            return article?.mobilecard_url ?? '';
        } else if (this.isTablet) {
            return article?.tabletcard_url ?? '';
        } else {
            return '';
        }
    }

    private processDisplayData() {
        // Transform API data to match the expected format of element
        if (this.whatsNewData && this.whatsNewData.length > 0) {
            const articles = this.whatsNewData || [];
            return articles.map((article: any) => ({
                image: article?.desktopcard_url,
                pImage: article?.tabletcard_url || article?.desktopcard_url,
                mImage: article?.mobilecard_url || article?.desktopcard_url,
                title: article.title || 'Default Title',
                description: article.shortdescription || 'Default Description',
                link: article.url || article.link || 'https://jc3sfg.com/',
                linkText: article.cta || 'Learn More',
            }));
        }
        return this.defaultWhatsNewData;
    }

    get sectionTitle() {
        return this.whatsNewData?.introWhatsNew?.[0]?.title;
    }
}
